import { useState, useEffect } from 'react';

/**
 * Debounced number input for TanStack Table column filter (minimum value).
 *
 * @param {number|string} value       Controlled value
 * @param {Function}      onChange    Called after debounce with new value (or '' to clear)
 * @param {string}        placeholder Input placeholder
 */
export default function NumberFilter( {
	value,
	onChange,
	placeholder = 'Mín.',
} ) {
	const [ local, setLocal ] = useState( value ?? '' );

	useEffect( () => {
		const t = setTimeout(
			() => onChange( local === '' ? '' : Number( local ) ),
			300
		);
		return () => clearTimeout( t );
	}, [ local ] );

	useEffect( () => {
		setLocal( value ?? '' );
	}, [ value ] );

	return (
		<input
			type="number"
			min="0"
			value={ local }
			onChange={ ( e ) => setLocal( e.target.value ) }
			placeholder={ placeholder }
			className={ `max-w-[8rem] px-3 py-2 border-2 border-black rounded-none shadow-sm focus:outline-none focus:border-blue ${
				local ? 'bg-white' : 'bg-gray-light'
			}` }
		/>
	);
}
